import dynamic from 'next/dynamic';

const TutorialLazy = dynamic(() => import('@/components/Tutorial/dynamic'));

const Tutorial = () => {
    return <TutorialLazy />;
};

export default Tutorial;
